import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';

import { WidgetPosition } from '@entities/WidgetPosition';
import appStore from '@stores/app.store';

@Component({
  tag: 'wog-thank-you',
})
export class ThankYou {
  @Prop() ratedValue: number;
  @Prop() thankYouMessageBad: string;
  @Prop() thankYouMessageGood: string;
  @Event() displayComplete: EventEmitter;

  componentDidLoad() {
    setTimeout(() => {
      this.displayComplete.emit();
    }, 2000);
  }

  private renderCustomMessage() {
    let message: string;
    if (this.ratedValue) {
      if (this.ratedValue <= 4) {
        message = this.thankYouMessageBad;
      } else {
        message = this.thankYouMessageGood;
      }
    } else {
      message = 'Thank you for your feedback.';
    }
    return <p class="wog--text-foundation wog--base-title wog--text-gray-800">{message}</p>;
  }

  render() {
    const configuration = appStore.get('configuration');
    const rootClass = {
      'wog--tab-view-container': true,
      'wog--flex': true,
      'wog--flex-1': true,
      'wog--flex-col': true,
      'wog--items-center': true,
      'wog--justify-center': true,
      'wog--py-8': true,
      'wog--px-4': true,
      'wog--text-center': true,
      'wog--thank-you-custom': true,
      'wog--mobile-full-position': true,
      'wog--position-left-side': configuration.position === WidgetPosition.MiddleLeft,
      'wog--position-right-side': configuration.position === WidgetPosition.MiddleRight,
      'wog--position-bottom-left': configuration.position === WidgetPosition.BottomLeft,
      'wog--position-bottom-right': configuration.position === WidgetPosition.BottomRight,
    };
    return <div class={rootClass} role="alert" >{this.renderCustomMessage()}</div>;
  }
}
